import React from "react";
import { Container } from "reactstrap";
import AppBreadcrumb from "../../Components/Common/AppBreadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import useInvoiceList from "./hooks/useInvoiceList";
import useInvoiceActions from "./hooks/useInvoiceActions";
import CostSummaryBar from "./components/costs/CostSummaryBar";
import UploadSection from "./components/import/UploadSection";
import FilterBar from "./components/filters/FilterBar";
import InvoiceTable from "./components/table/InvoiceTable";
import PaginationFooter from "./components/table/PaginationFooter";
import EditInvoiceModal from "./components/EditInvoiceModal";

const VendorInvoices = () => {
  const list    = useInvoiceList();
  const actions = useInvoiceActions({ onRefresh: list.refresh });

  return (
    <div className="page-content">
      <DeleteModal
        show={actions.deleteModal.show}
        onDeleteClick={actions.deleteModal.onConfirm}
        onCloseClick={actions.deleteModal.onCancel}
      />
      <EditInvoiceModal
        {...actions.editModal}
        phases={list.phases}
        onSaved={list.refresh}
      />
      <Container fluid>
        <AppBreadcrumb />
        <CostSummaryBar data={list.costSummary} />
        <UploadSection onSuccess={list.refresh} />
        <FilterBar
          count={list.pagination?.count ?? list.invoices.length}
          filters={list.filters}
          phases={list.phases}
          costTypes={list.costTypes}
          onChange={list.setFilters}
          onAdd={actions.openAdd}
        />
        <InvoiceTable
          invoices={list.invoices}
          loading={list.loading}
          onEdit={actions.openEdit}
          onDelete={actions.openDelete}
        />
        <PaginationFooter
          pagination={list.pagination}
          currentPage={list.currentPage}
          loading={list.loading}
          onNext={() => list.nextPage(list.pagination)}
          onPrev={() => list.prevPage(list.pagination)}
        />
      </Container>
    </div>
  );
};

export default VendorInvoices;
